import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Near-monochrome UI with one accent. Side colors appear only on the flow.
const ink: MantineColorsTuple = ['#f7f7f8', '#ececef', '#d6d6dc', '#b9b9c3', '#9a9aa6', '#7d7d8a', '#636370', '#4b4b57', '#33333d', '#1f1f27'];

export const theme = createTheme({
  primaryColor: 'ink',
  primaryShade: { light: 8, dark: 3 },
  colors: { ink },
  // Tight corners: 3px on controls, 2px on badges (4px+ reads as "bubbly" on a dense screen).
  radius: { xs: '2px', sm: '3px', md: '5px', lg: '8px', xl: '12px' },
  defaultRadius: 'sm',
  // Resolved in ui/global.css from the judge's font setting (Settings → Display).
  fontFamily: 'var(--font-ui)',
  fontFamilyMonospace: 'var(--font-mono)',
  headings: { fontWeight: '600' },
  cursorType: 'pointer',
  components: {
    Button: { defaultProps: { variant: 'default' } },
    Badge: { defaultProps: { radius: 'xs' }, styles: { root: { letterSpacing: '0.02em' } } },
    ActionIcon: { defaultProps: { variant: 'subtle', color: 'gray' } },
    Tooltip: { defaultProps: { openDelay: 400, withArrow: true } },
  },
});
